import React, { createContext, useContext } from 'react';

const AdminAppContext = createContext(false);

export const AdminAppProvider = ({ children }: { children: React.ReactNode }) => (
  <AdminAppContext.Provider value={true}>{children}</AdminAppContext.Provider>
);

export const useIsAdminApp = () => useContext(AdminAppContext);
